import { IonHeader, IonToolbar, IonTitle } from '@ionic/react';

import * as styles from './CollapsibleHeading.css';

interface CollapsibleHeadingProps {
  title: string;
}

/**
 * This component exists to enable a condensed header on Android and iOS (https://ionicframework.com/docs/api/header#condensed-header)
 * Ionic v7 does not natively support condensed headers on Android, so we must craft our own implementation. This is done by setting
 * the IonHeader mode to "ios" and some addional styling on .header-collapse-condense which is found in @/styles/ionic/styles.css.
 *
 * More info here: https://github.com/ionic-team/ionic-framework/issues/25157#issuecomment-1103599308
 *
 * @param {CollapsibleHeadingProps} { title }
 * @return {*}
 */
export const CollapsibleHeading = ({ title }: CollapsibleHeadingProps) => {
  return (
    <IonHeader collapse="condense" mode="ios">
      <IonToolbar className={styles.toolbar}>
        <IonTitle className={styles.title} size="large">
          {title}
        </IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};
